import { Injectable, signal } from "@angular/core";

/**
 * Tracks the expanded/collapsed state of column components within a single
 * AssigneesColumnsWrapperComponent tree. Provided at the wrapper component
 * level so each wrapper has its own isolated instance.
 */
@Injectable()
export class ColumnStateService {
    private readonly expandedStates = signal<ReadonlyMap<string, boolean>>(new Map());

    setExpanded(columnId: string, expanded: boolean): void {
        this.expandedStates.update((map) => new Map(map).set(columnId, expanded));
    }

    deregister(columnId: string): void {
        this.expandedStates.update((map) => {
            const next = new Map(map);
            next.delete(columnId);
            return next;
        });
    }

    /** Returns the live signal value — read this inside reactive contexts to track changes. */
    getStates(): ReadonlyMap<string, boolean> {
        return this.expandedStates();
    }
}
